import React from 'react';
import {WebsocketContext} from './WebsocketProvider';

export function useWebsocket() {
  const context = React.useContext(WebsocketContext);

  if (context === undefined) {
    throw new Error(`useWebsocket must be used within a WebsocketProvider`);
  }
  return context;
}
